// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ndiv[data-v-67b237e4] {\n  /* min-height: 250px; */\n}\n.custom-marker[data-v-67b237e4] {\n  width: 30px;\n  height: 30px;\n  padding-top: 1px;\n  background-color: #ff5c00;\n  font-weight: 900;\n  border-radius: 50%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
